import { BreadcrumbItem, TabOption } from '@flowww/apps-design-system';
import { FamilyFolderModel } from '../../shared/models/family-folder.model';

/** Mapeo de familias */
export function mapFamilyTab(family: FamilyFolderModel): TabOption {
    const tab: TabOption = { label: family.description, value: family.id };
    return tab;
}

/**
 * Selection path de la familia
 */
export function computeDefaultFamilyPath(rootValue: string): string[] {
    return [rootValue];
}

/** Recorre las familias hasta las subfamilias */
export function resolveFamilyByPath(families: FamilyFolderModel[], path: string[]): FamilyFolderModel | undefined {
    let nodes = families ?? [];
    let found: FamilyFolderModel | undefined;

    for (const value of path ?? []) {
        found = nodes.find((family) => family.id === value);
        if (!found) {
            return undefined;
        }
        nodes = found.families ?? [];
    }

    return found;
}

/** Trail de breadcrumb del path activo, para llenar flw-breadcrumb. */
export function buildBreadcrumbTrail(families: FamilyFolderModel[], path: string[]): BreadcrumbItem[] {
    const trail: BreadcrumbItem[] = [];
    let nodes = families ?? [];

    for (const value of path ?? []) {
        const found = nodes.find((family) => family.id === value);
        if (!found) {
            break;
        }
        trail.push({ label: found.description, value: found.id });
        nodes = found.families ?? [];
    }

    return trail;
}

/** Cuenta servicios/productos/packs dentro de una familia y todas sus subfamilias, para el count del selector. */
export function countItemsInFamily(family: FamilyFolderModel): number {
    const ownItems =
        (family.services ?? []).length +
        (family.products ?? []).length +
        (family.packs ?? []).length;

    const childrenItems = (family.families ?? []).reduce(
        (total, child) => total + countItemsInFamily(child),
        0,
    );

    return ownItems + childrenItems;
}
